export default Object.freeze({
  GraduateWithDiploma: 1,
  ReceivedCertificate: 2,
  ReachedMaximumAge: 3,
  StudentDoesNotHaveDisability: 4,
  StudentDoesNotHaveActiveReferralWithCorporation: 5,
})
